let cachedPromise = null;

export function fetchCaseInfo(route, token) {
  if (!cachedPromise) {
    const headers = {};
    if (token) headers.Token = token;

    cachedPromise = fetch(`${route}/listcasesinfo.webapi`, {
      method: "GET",
      headers: headers,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .catch(function (error) {
        // Don't memoize a failure — otherwise every caller for the rest of
        // the session would be stuck re-resolving the same rejected promise.
        // The next caller gets to retry the real fetch.
        cachedPromise = null;
        throw error;
      });
  }
  return cachedPromise;
}

export function clearCaseInfoCache() {
  cachedPromise = null;
}